import { trpc } from "@/trpc/react";

export const useSettings = (name: string) => {
  const { data } = trpc.settings.listSettings.useQuery();

  if (!data) {
    return null;
  }

  const setting = data.find((setting) => setting.name === name);

  return setting?.value || null;
};